import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "department-history-force-edit",
  components: {
    AppHeader
  },
  async created() {
    await this.getUser();
    this.getDepartment();
    await this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      departmentHistories: [
        {
          year: "",
          month: "",
          day: "",
          user_id: this.$route.params.user_id,
          department_id_before: "",
          department_name_before: "",
          department_id_after: "",
          department_name_after: ""
        }
      ],
      departments: "",
      getDepartmentEnd: false,
      errorInfo: "",
      user: "",
      savingFlag: false
    };
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getDepartment() {
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentEnd = true;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
    },
    async forceChangeDepartmentHistory() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let latestDate = "0000-00-00";
      let latestDepartment_id = "";
      for (let i = 0; i < this.departmentHistories.length; i++) {
        this.departmentHistories[i].change_date = dayjs(
          `${this.departmentHistories[i].year}-${this.departmentHistories[i].month}-${this.departmentHistories[i].day}`
        ).format("YYYY-MM-DD");
        if (
          this.departmentHistories[i].change_date > dayjs().format("YYYY-MM-DD")
        ) {
          this.errorInfo = "未来日付のデータが存在します。";
          return;
        }
        if (latestDate < this.departmentHistories[i].change_date) {
          latestDate = this.departmentHistories[i].change_date;
          latestDepartment_id = this.departmentHistories[i].department_id_after;
        }
      }
      if (this.user.department_id != latestDepartment_id) {
        this.errorInfo =
          "最新の部署と社員に設定されている部署に相違があります。";
        return;
      }
      let data = this.departmentHistories;
      let res = await this.$store
        .dispatch("FORCE_UPDATE_DEPARTMENT_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goDepartmentHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goDepartmentHistory() {
      this.$router.push({
        path: `/department_history/${this.$route.params.user_id}`
      });
    },
    addDepartmentHistory() {
      let departmentHistory = {
        year: "",
        month: "",
        day: "",
        user_id: this.$route.params.user_id,
        department_id_before: "",
        department_name_before: "",
        department_id_after: "",
        department_name_after: ""
      };
      this.departmentHistories.push(departmentHistory);
    },
    removeDepartmentHistory: function(index) {
      this.departmentHistories.splice(index, 1);
    },
    changeDepartmentBefore(index) {
      let findDepartment = this.departments.find(
        department =>
          department.id == this.departmentHistories[index].department_id_before
      );
      this.departmentHistories[index].department_name_before =
        findDepartment.name;
    },
    changeDepartmentAfter(index) {
      let findDepartment = this.departments.find(
        department =>
          department.id == this.departmentHistories[index].department_id_after
      );
      this.departmentHistories[index].department_name_after =
        findDepartment.name;
    }
  }
};
